import React from "react";
import { VscCloudDownload } from "react-icons/vsc";
import { MdOutlineErrorOutline } from "react-icons/md";
import { Spinner } from 'react-bootstrap';

const EntriesPerPage = ({ data, entriesperpage, setEntriesPerPage }) => (




  <div id="entries-perpage">
    {data?.length > 1 && (
      <span className="entriesperpage-span">
        Show
        <select
          value={entriesperpage}
          onChange={(e) => setEntriesPerPage(e.target.value)}>
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        entries
      </span>

    )}

  </div>

);
const customId = "custom-id-yes";
const tokenKey = "svd-sYUDugysad-sdkjhsadkrjyteyugd--dskghjksdh";
const TableFetch = ({ colSpan }) => (
  <tr>
    <td colSpan={colSpan} className="table-msg">
      <VscCloudDownload size={75} />
      <p>Fetching request...</p>
    </td>
  </tr>
);
const NoRecordFound = ({ colSpan, children }) => (
  <tr>
    <td colSpan={colSpan} className="table-msg">
      <MdOutlineErrorOutline size={75} />
      <p>{children}</p>
    </td>
  </tr>
);


const TableProgressBar = () => (
  <div id="container-progressbar">
    <div id="bar"></div>
  </div>
);


const Spinners = ({ size }) => (
  <Spinner
    as="span"
    animation="border"
    size={size}
    role="status"
    aria-hidden="true"
  />
);

const Wave = () => (
  <div id="spinner-wave" >
    <div className="sp-load sp-wave"></div>
  </div>
);


const Search = ({ searchItem, setSearchItem, placeholder }) => (
  <input
    className='search__input'
    type="text"
    value={searchItem}
    onChange={(e) => setSearchItem(e.target.value)}
    placeholder={placeholder} />
);

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

export { TableFetch, EntriesPerPage, NoRecordFound, TableProgressBar, Spinners, Search, Wave, tokenKey, customId, months };
